import Modal from '@/components/Modal';
import { formatFileSize } from '@/utils/file.utils';
import { hideModal } from '@/utils/modal.utils';

type PdfProgressModalProps = {
  id: string;
  progress: number;
  totalSize: number;
  currentSize: number;
  onClose?: () => void;
};

const PdfProgressModal = ({
  id,
  progress,
  // totalSize,
  currentSize,
  onClose,
}: PdfProgressModalProps) => {
  const cancelPdfGeneration = () => {
    hideModal(id);
    onClose?.();
  };

  return (
    <Modal
      id={id}
      title="Génération du PDF"
      size="small"
      centerY
      showFooter={false}
      onEscapePress={cancelPdfGeneration}
      onClickOutsideContent={cancelPdfGeneration}
      onClose={cancelPdfGeneration}
    >
      <div className="w-[180px]">
        <div className="flex items-center gap-2">
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div
              className="bg-purple-5433FF h-2.5 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="text-sm text-gray-800">{progress.toFixed(0)}%</div>
        </div>
        <div className="mt-1 text-sm text-gray-600">
          {formatFileSize(currentSize)}
          {/* <div>/</div>
          <div>{formatFileSize(totalSize)}</div> */}
        </div>
      </div>
    </Modal>
  );
};

export default PdfProgressModal;
